import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

const ContabilidadDashboardDefault = Loadable(lazy(() => import('pages_contabilidad/dashboard/default')));
const ContabilidadMediaFacturaCobro = Loadable(lazy(() => import('pages_contabilidad/media_factura_cobro')));
const ContabilidadMediaFacturaPago = Loadable(lazy(() => import('pages_contabilidad/media_factura_pago')));
const ContabilidadPago60Auditoria = Loadable(lazy(() => import('pages_contabilidad/pago_60_auditoria')));

const ContabilidadRoutes = {
  path: '/contabilidad',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="/contabilidad/dashboard/media-factura-cobro" replace />
    },
    {
      path: 'dashboard',
      children: [
        {
          index: true,
          element: <Navigate to="/contabilidad/dashboard/media-factura-cobro" replace />
        },
        {
          path: 'default',
          element: <ContabilidadDashboardDefault />
        },
        {
          path: 'media-factura-cobro',
          element: <ContabilidadMediaFacturaCobro />
        },
        {
          path: 'media-factura-pago',
          element: <ContabilidadMediaFacturaPago />
        },
        {
          path: 'pago-60-auditoria',
          element: <ContabilidadPago60Auditoria />
        }
      ]
    },
    {
      path: 'resumen',
      element: <Navigate to="/contabilidad/dashboard/default" replace />
    },
    {
      path: 'media-factura-cobro',
      element: <Navigate to="/contabilidad/dashboard/media-factura-cobro" replace />
    },
        {
      path: 'media-factura-pago',
      element: <Navigate to="/contabilidad/dashboard/media-factura-pago" replace />
    },
    {
      path: 'pago-60-auditoria',
      element: <Navigate to="/contabilidad/dashboard/pago-60-auditoria" replace />
    }
  ]
};

export default ContabilidadRoutes;
